import messages from "components/UI/messages_fr";

let local = {

  home: 'Accueil',
  subscribeAction: "Je m'inscris",

  newsSoonAvailable: "Bientôt disponible !",
  newsNew: "Nouveau",
  newsShowMore: "Voir plus",
  newsClose: "Fermer",
  newsReplay: "Replay",
  newsEvent: "Webconference",
  newsFlash: "Information",

  commonBack: 'Retour',
  commonError: 'Erreur',
  footerLegalNotice: "© 2022 Sobi. Tous droits réservés - NP-20708",

  accountFormTitle: 'Mon compte',
  accountDeleteButton: 'Supprimer mon compte',
  accountDeleteTitle: "Suppression de votre compte",
  accountDeleteText: "Attention !\nLa suppression de votre compte est définitive !!!",
  accountDeleteBtConfirm: "Je confirme vouloir supprimer mon compte",
  accountCurrentPassword: "Mot de passe actuel",
  accountDeleteMustSpecifyPassword: "Veuillez saisir votre mot de passe.",
  accountChangePassBt: 'Modifier mon mot de passe',
  accountEmail: 'Email',
  accountFirstname: 'Prénom',
  accountLastname: 'Nom',
  accountJob: 'Profession',
  accountYourAccount: 'Votre compte',
  accountPresent: 'Présent(e)',
  accountData: 'Identification',
  accountAddress: 'Coordonnées',
  accountAccessRestricted: 'Accès Administrateur',
  accountCategoryImmunologia: 'Immunologie',
  accountCategoryHemophilia: 'Hémophilie',

  eventPresent: 'Présent(e)',
  eventData: 'Informations',


  loginAction: "Connexion",
  loginForgotPassword: 'Mot de passe oublié ?',
  loginForgotPasswordText: "Saisissez votre identifiant afin de recevoir un mail qui vous\npermettra de changer votre mot de passe",
  loginFieldEmail: 'Email',
  loginFieldPassword: 'Mot de passe',
  loginFormSubmit: "Je me connecte",
  liveClickToRedirect: "Cliquez pour être redirigé vers la salle de la webconférence",
  liveMustConfigureEmbed: "Vous devez configurer la vidéo ou le lien externe de cet événement !!!",
  helpBannerTitle: "Besoin d'aide pour utiliser l'outil ?",
  helpBannerGotoHelp: 'Rubrique aide',
  helpBannerGotoContact: 'Nous contacter',

  eventDescription: "Description",
  eventDate: "Date",
  eventDates: "Date(s)",
  eventProgram: "Programme",
  eventAnimatedBy: "Animé(e) par : ",
  eventDuration: "Durée : ",
  homeBanner: "Plateforme réservée aux professionnels de santé",
  homeIntroTitle: "Des évènements en direct et interactifs",
  homeIntroSubTitle: "Mis en place par votre interlocuteur Sobi",
  homeAvailableEvents: "Nos webconférences",
  homeYourEvents: "Mon agenda",
  homeReplays: "Nos Replays",

  loading: "Chargement",
  helpTitle: "Aide",
  speedTestButtonLabel: 'Testez votre connexion internet',
  speedTestButtonStart: 'Lancer le test',
  speedTestButtonRestart: 'ReLancer le test',

  contactFormTitle: "Contactez-nous",
  contactFormSuccess: "Nous vous recontacterons dans les plus brefs délais.",
  formFieldsRequiredLegend: "* Champs obligatoires",
  formPleaseMakeSelection: "Veuillez faire votre choix",
  formCancel: "Annuler",

  liveAction: "Regarder",
  liveEventIsStarted: "Live !",
  liveYourEventStartsIn: "Votre webconférence débute dans :",
  liveClickToRefreshPage: "Cliquez pour recharger la page et accéder au live",
  liveClickToRefreshPageAndGotoLive: "Cliquez pour recharger la page et accéder au live",
  ClickToRefreshPage: "Cliquez pour recharger la page",

  loginFormTitle: "J'ai déjà un compte",
  subscriptionAction: "S'inscrire",
  subscriptionTitle: 'Inscription',
  subscriptionSubTitle: "Je souhaite m'inscrire aux prochains événements",
  subscriptionVerifiedSuccessTitle: 'Votre inscription a bien été\n prise en compte',
  subscriptionMemberSuccessTitle: 'Votre inscription a bien été\n prise en compte',
  subscriptionPendingSuccessTitle: "Votre inscription est en cours de validation. Vous recevrez un email d'ici 48 heures. Vous pourrez alors vous inscrire aux évènements de votre choix. Vérifiez vos spams.",
  subscriptionShowProgram: 'Programme',
  subscriptionAlreadyExists: "Déjà inscrit(e)",
  subscriptionAlreadyExistsLong: "Déjà inscrit(e) à la date sélectionnée",
  subscriptionMustChoseDate: "Veuillez choisir une date ci-dessus",
  subscriptionHasNoId: "Je n'ai pas de numéro RPPS/ADELI",
  subscriptionHasRpps: 'J’ai un numéro RPPS',
  subscriptionHasAdeli: 'J’ai un numéro ADELI',
  subscriptionHasRppsAndJob: 'J’ai un numéro RPPS',
  subscriptionFormInstructions: 'Indiquez vos noms/prénoms tels que sur votre carte professionnelle',
  subscriptionHasNoRpps: 'Je n’ai pas de numéro RPPS/ADELI',

  subscriptionSelfTitleSingle: "Pour vous inscrire à votre réunion,\nmerci de vous identifier ou de créer un compte",
  subscriptionSelfTitlePlural: "Pour vous inscrire à vos réunions,\nmerci de vous identifier ou de créer un compte",
  subscriptionFormNotice: "Sauf mention contraire, tous les champs sont obligatoires pour valider votre inscription.\n\nVotre numéro de téléphone servira exclusivement à l'envoi de rappels avant le début de la webconférence. Il ne sera pas utilisé par Sobi France à des fins publicitaires ou commerciales.\n\nVos données personnelles font l'objet d'un traitement par Kparticulier pour le compte de Sobi France aux fins de gestion de votre participation à la webconférence : inscription, vérification de votre qualité de professionnel de santé, envoi de rappels, questions lors des sessions, suivi de votre participation, évaluation de la qualité des webconférences, et le cas échéant, si vous y consentez, aux fins de suivi des campagnes d'e-mailings de rappel et évaluation de vos préférences sur la plateforme en vue en vue de vous partager des communications et offres de services personnalisées en fonction de vos thématiques d'intérêt.\n\nVous pouvez le cas échéant, accéder à vos données, les rectifier, les effacer, limiter ou vous opposer à leur traitement, demander leur portabilité, ainsi que définir des directives relatives au sort de vos données après votre décès.\n\nVous pouvez exercer vos droits aux coordonnées suivantes : RDP.FR@sobi.com ou Immeuble Pacific - 11-13 Cours Valmy 92800 Puteaux.\n\nPour une information complète relative au traitement de vos données, veuillez consulter la [local url=/confidentiality]Politique de Confidentialité[/local].\n\nVous n'êtes pas autorisé à effectuer des captures photo ou vidéo des webconférences. Toute exploitation illicite ou déloyale, toute utilisation susceptible de porter atteinte à la dignité, la réputation ou à la vie privée des intervenants ou de Sobi, ainsi que toute autre exploitation préjudiciable selon les lois et règlements en vigueur pourra faire l'objet de poursuites.",
  jobMd: 'Médecin',
  jobPh: 'Pharmacien',
  jobIn: 'Infirmier',
  jobInt: 'Interne',
  jobX5: 'Interne sans RPPS',
  jobX7: 'Préparateur',
  jobX2: "Médecin",
  jobX4: 'Pharmacien',
  jobX3: 'Infirmier',
  jobLb: 'Sobi',

  navHome: "Accueil",
  navContact: "Contact",
  navHelp: "Aide",
  navReplays: "Replays",
  navLegal: "Conditions générales",
  navConfidentiality: "Données personnelles",
  navMyAccount: 'Mon compte',
  navCookies: 'Politique de cookies',
  navAccounts: 'Professionnels',
  navEvents: 'Evénements',
  navThemes: 'Thèmes',
  navModerator: 'Modération',
  navExports: 'Exports',
  navFaq: 'Admin Aide',
  adminCms: 'Admin CMS',
  navNews: 'Admin News',
  navUtms: 'Admin UTMs',
  navLogs: 'Admin Logs',
  navEmails: 'Admin Emails',
  navInvite: 'Invitations',
  
  replayNext: 'Replay suivant >',
  replayPrevious: '< Replay précédent',
  replayAction: "Regarder",
  replaysTitle:"Replays",
  replayTimecodesToggler: 'Chapitres',
  replayTimecodeTitle: "Chapitres",
  replayCopyrightWarning: "Tout enregistrement, reproduction, diffusion, publication ou retransmission du contenu de cette webconférence est strictement interdit sans l'autorisation écrite du détenteur des droits d'auteur.",

  liveMustLoginFirst: "Merci de vous connecter, ou de créer un compte pour accéder à ce contenu",
  liveCopyrightWarning: "Tout enregistrement, reproduction, diffusion, publication ou retransmission du contenu de cette webconférence est strictement interdit sans l'autorisation écrite du détenteur des droits d'auteur.",
  liveHelpTitle: "Comment bien visualiser votre live ?",
  liveHelpMore: "Voir les autres conditions de visualisation",
  liveHelpDetails: "* Lore ipsum lorem ipsum lorem ipsum.",
  liveLegalFile: "Mentions légales",
  eventStateLive: 'Live',
  eventStateOnline: 'En ligne',
  eventStatePending: 'À venir',
  eventStateFinished: 'Terminé',
  eventStateReplay: 'Replay',

  footerLegalText: false,

  feedbackSuccess: "Votre évaluation a bien été enregistrée !",
  feedbackMustAnswerAll:
  "Merci de répondre à toutes les questions afin d'envoyer le formulaire...",

  quizSend: "Envoyer",
  quizInstructionsPlural:
  "Veuillez choisir de 1 à {max} réponse(s) parmi les {size} possibles.",
  quizInstructionsSingle:
  "Veuillez choisir 1 réponse parmi les {size} possibles.",
  quizSuccess: "Votre réponse a bien été enregistrée !",
  quizMustChose: "Veuillez faire votre choix afin d'envoyer votre réponse",
  quizQuestionActivate: "Activer",
  quizQuestionIsActive: "Activée",
  quizResults: "Résultats :",

  navDashboard: "Dashboard",
  dashboardStatsUsersTitle: "Inscrits",
  dashboardStatsEventsTitle: "Emissions",
  dashboardStatsTotal: "Total",
  dashboardStatsPending: "En attente",
  dashboardNavigationTitle: "Navigation",
  dashboardNavigationAccounts: "Annuaire des professionnels de santé",
  dashboardNavigationEvents: "Liste des événements",
  dashboardNavigationStats: "Statistiques",
  dashboardNavigationStatsLocations: "Lieu d'exercice",
  dashboardNavigationStatsExercise: "Mode d'exercice",
  dashboardNavigationStatsSpeciality: "Spécialité",
  dashboardNavigationStatsJobs: "Professions",
  dashboardNavigationStatsRegistrations: "Dates de création de comptes",
  dashboardNavigationStatsSubscriptions: "Dates d'inscription aux événements",
  dashboardNavigationExports: "Exports",
  dashboardStatsSpecialityX: 'Spécialités',
  dashboardStatsSpecialityY: 'Nombre de comptes',
  dashboardStatsJobsX: 'Profession',
  dashboardStatsJobsY: 'Nombre de comptes',
  dashboardStatsSubscriptionsX: '',
  dashboardStatsSubscriptionsY: 'Nombre d\'inscriptions aux événements',
  dashboardStatsRegistrationsX: '',
  dashboardStatsRegistrationsY: 'Nombre d\'inscriptions à la plateforme',

  dashboardExportsEvents: 'Emissions',
  dashboardExportsRegistrations: 'Inscriptions',
  dashboardExportsFeedbacks: 'Feedbacks',
  dashboardExportsReplays: 'Replays',
  dashboardExportsOrders: 'Commandes',

  accountMustChangeOptins: "POUR CONTINUER D'UTILISER VOTRE SITE, merci de VÉRIFIER VOS PRÉFÉRENCES DE NOTIFICATIONS",
  accountChangeOptinsBt: "Préférences de notification",

  rgpdPopin:
  "Nous utilisons les cookies nécessaires pour faire fonctionner notre site.\nPour plus d'informations sur les cookies que nous utilisons, consultez notre [local url=/cookies]Politique de Cookies[/local].\n\n[small][u]Cookies nécessaires : [/u][/small]\n[small]Nous utilisons des cookies nécessaires au fonctionnement du site Web, ils ne peuvent pas être désactivés dans nos systèmes. Vous pouvez configurer votre navigateur afin de bloquer ou être informé de l'existence de ces cookies, mais certaines parties du site Web peuvent être affectées. Ces cookies ne stockent aucune information d'identification personnelle.[/small]",
  rgpdAccept: "Fermer",

  studentRegisterMessageEmail:"autorisation@webconf-sobi.com",
  studentRegisterMessageDownload:"/files/Autorisation_Webconf-sobi.com.pdf?r1",

};

export default { ...messages, ...local };




// WEBPACK FOOTER //
// ./src/i18n/sobi_france_fr.js